import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Chart from "./Chart";
const ChartsPage = () => {
  const [weightUnit, setWeightUnit] = useState("metric");
  const weightUnitStore = useSelector((state) => state.user.weightUnit);

  useEffect(() => {
    if (weightUnitStore) {
      setWeightUnit(weightUnitStore);
    }
  }, [weightUnitStore]);

  const chartDataString = localStorage.getItem("currentDayData");
  const chartData = JSON.parse(chartDataString);

  return (
    <motion.div
      exit={{ opacity: 0, x: "100vw" }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <Chart chartData={chartData} weightUnit={weightUnit} />
    </motion.div>
  );
};

export default ChartsPage;
